import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  width: 300px;
  z-index: 20000;
  top: 16px;
  right: 16px;
`;

export const Message = styled.div`
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 4px;
`;

export const ErrorMessage = styled(Message)`
  color: #ffffff;
  background: #C7094D;
`;

export const SuccessMessage = styled(Message)`
  color: #ffffff;
  background: #007A5A;
`;
